<template>
<div class="table-responsive">
    <table :class="renderTableClass">
        <thead class="thead-dark">
            <tr v-if="elements && type === 'view'">
                <th v-for="(head, headIndex) in elements" :key="headIndex">{{ head.title }}</th>
            </tr>
            <tr v-if="elements && type === 'input'">
                <th><button @click="addRow" type="button" class="btn btn-outline-light btn-sm rounded-circle"><i class="fas fa-plus"></i></button></th>
                <th v-for="(head, headIndex) in elements" :key="headIndex">{{ head.title }}</th>
            </tr>
        </thead>
        <tbody v-if="type === 'view'">
            <tr v-for="(data, rowIndex) in collections" :key="rowIndex" :class="styleSelectedRow(data.id)" @click.prevent="selectRow(data.id)">
                <td v-for="(element, colIndex) in elements" :key="colIndex" >
                    <!-- <input v-if="element.isInput" :type="element.type" v-model="data[element.column]"> -->
                    <div>{{ (element.type === 'date') ? moment(data[element.column]).format('L') : (element.type === 'number') ? numeral(data[element.column]).format('0,0') : data[element.column] }}</div>
                </td>
            </tr>
        </tbody>
        <tbody v-if="type === 'input'">
            <tr v-for="(data, rowIndex) in collections" :key="rowIndex">
                <td><button @click="delRow(rowIndex)" type="button" class="btn btn-outline-dark btn-sm rounded-circle"><i class="fas fa-minus"></i></button></td>
                <td v-for="(element, colIndex) in elements" :key="colIndex" >
                    <input v-if="element.type !== 'lookup'" :disabled="element.disable" :style="{ width: `${element.width*50}px` }" :type="element.type" v-model="data[element.column]">
                    <div :style="{ width: `${element.width*50}px` }">
                        <app-lookup-field v-if="element.type === 'lookup'" :rowIndex="rowIndex" :headerModel="headerModel" :model="data" :element="element.lookup" v-on:selectLookup="finishLookup" v-on:selectedRowIndex="selectRowModal"></app-lookup-field>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import AppLookupField from './AppLookupField.vue'

export default {
    props: ['type', 'elements', 'headerModel', 'collections', 'newData'],
    components: {
        AppLookupField
    },
    data() {
        return {
            selectedId: 0,
            selectedRowDetailId: -1
        }
    },
    computed: {
        renderTableClass() {
            return (this.type === 'view') ? 'table table-hover' : 'table table-borderless table-sm'
        }
    },
    methods: {
        selectRow(id) {
            this.selectedId = id
            this.$emit('selectedRow', id)
        },
        styleSelectedRow(id) {
            if(this.selectedId === id) {
                return 'table-success'
            }
        },
        addRow() {
            this.collections.splice(this.collections.length + 1, 0, { ...this.newData })
        },
        delRow(index) {
            this.collections.splice(index, 1)
        },
        finishLookup(data) {
            const currentData = this.collections[this.selectedRowDetailId]
            this.collections.splice(this.selectedRowDetailId, 1, {
                ...currentData,
                ...data
            })
        },
        selectRowModal(rowIndex) {
            this.selectedRowDetailId = rowIndex
        },
    }
}
</script>